import React from "react"
import { ITextProps } from "../../types/textTypes"

interface Props extends ITextProps {
  className?: string
  id: string
}

const Reference = (props: Props) => {
  const scrollToBottom = () => {
    document
      .getElementById(props.id)
      ?.scrollIntoView({ block: "end", behavior: "smooth" })
  }

  return (
    <span
      onClick={scrollToBottom}
      className={`${props.className} cursor-pointer`}
    >
      {props.children}
    </span>
  )
}

export default Reference
